import { CURRENCY_CRYPTO_NAME } from "../../constants";

export default function CryptoCurrency({ currency }) {
  const filterCurrency = CURRENCY_CRYPTO_NAME.find(x=>x.value === currency)
  return (
    <>
      {filterCurrency?.label || "-"}
    </>
  );
}
